import { render } from "./AddPackage.vue?vue&type=template&id=0b675a20"
import script from "./AddPackage.vue?vue&type=script&lang=js"
export * from "./AddPackage.vue?vue&type=script&lang=js"

import "./AddPackage.vue?vue&type=style&index=0&id=0b675a20&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__